import React from 'react';

import { CurrentuserContext } from '@uplift/contexts';
import { meToCurrentUser, useCurrentUser } from '@uplift/queries';
import { CurrentUser } from '@uplift/api';

export const CurrentUserProvider = ({ children, isLoggedIn, accessToken }) => {
  const { data, isLoading } = useCurrentUser(!isLoggedIn, accessToken);

  const finalCurrentUser: CurrentUser = React.useMemo(() => {
    if (isLoggedIn && data) {
      return meToCurrentUser(data);
    }

    return { isLoading } as CurrentUser;
  }, [ data, isLoggedIn, isLoading ]);

  return (
    <CurrentuserContext.Provider value={finalCurrentUser}>
      {children}
    </CurrentuserContext.Provider>
  );
};
